module.exports = __webpack_public_path__ + "static/media/timer-in-head.1b39d60d.svg";